import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "center-div",
  style: {"position":"relative"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"margin-left":"0px"} }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "vote-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_LikeOutlined = _resolveComponent("LikeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    class: "center-container",
    style: {"background-color":"#fff"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_affix, { "offset-top": 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              width: "300px",
              style: _normalizeStyle([{ overflow: 'auto', height: '90vh', position: 'absolute', background: '#fff', left: 0, top: '65px', bottom: 0 }, {"margin-bottom":"150px"}])
            }, {
              default: _withCtx(() => [
                (_ctx.level1.length > 0)
                  ? (_openBlock(), _createBlock(_component_a_tree, {
                      key: 0,
                      "show-line": true,
                      "show-icon": true,
                      "tree-data": _ctx.level1,
                      onSelect: _ctx.onSelect,
                      replaceFields: { label: 'name', title: 'name', key: 'id', value: 'id' },
                      defaultExpandAll: true,
                      defaultSelectedKeys: _ctx.defaultSelectedKeys,
                      style: {"margin-left":"10px"}
                    }, null, 8, ["tree-data", "onSelect", "defaultSelectedKeys"]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_a_spin, {
                      key: 1,
                      style: {"margin-top":"150px","margin-left":"140px"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, {
          style: _normalizeStyle([{ background: '#fff', padding: '75px 24px 24px 24px', margin: 0, minHeight: '720px' }, {"margin-left":"300px"}])
        }, {
          default: _withCtx(() => [
            (!_ctx.loading && _ctx.level1.length === 0)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "对不起，找不到相关文档！"))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "加载文档中，请稍后..."))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_breadcrumb, {
                    separator: ">",
                    style: {"margin":"0px 0px 20px 10px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_breadcrumb_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: '/' }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 首页 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_breadcrumb_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: { path: '/', query: { 'id1': _ctx.ebook.category1.id, 'id2': _ctx.ebook.category2.id, 'type': 1 } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.ebook.category1.name), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_breadcrumb_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: { path: '/', query: { 'id1': _ctx.ebook.category1.id, 'id2': _ctx.ebook.category2.id, 'type': 2 } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.ebook.category2.name), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_breadcrumb_item, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ebook.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.doc.name), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, "阅读数：" + _toDisplayString(_ctx.doc.viewCount), 1),
                  _createTextVNode("     "),
                  _createElementVNode("span", null, "点赞数：" + _toDisplayString(_ctx.doc.voteCount), 1)
                ]),
                _createVNode(_component_a_divider, { style: {"height":"2px","background-color":"#9999cc"} })
              ]),
              _createElementVNode("div", {
                class: "wangeditor",
                innerHTML: _ctx.html
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  shape: "round",
                  size: 'large',
                  onClick: _ctx.vote
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_LikeOutlined),
                    _createTextVNode("  点赞：" + _toDisplayString(_ctx.doc.voteCount), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_TheFooter)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_back_top, { type: "default" })
    ]),
    _: 1
  }))
}